module.exports = __webpack_public_path__ + "img/toscana-desktop.dc6c8ac4.jpg";